'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = require('Cookies');

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NONCE_COOKIE = 'hsgn';

exports.default = {
  get: function get() {
    return _Cookies2.default.get(NONCE_COOKIE);
  },
  store: function store(_ref) {
    var nonce = _ref.nonce;

    _Cookies2.default.set(NONCE_COOKIE, nonce, {
      path: '/',
      secure: true,
      expires: 1 / 48
    });
  }
};
module.exports = exports['default'];